import getComingSoon from "@/api/getComingSoon";
import { useQuery } from "@tanstack/react-query";
import type { ComingSoon } from "@/types";


const useComingSoon = () => {
    const { data,isLoading,isError,error,refetch } = useQuery<ComingSoon[], Error>({
        queryKey: ["comingSoon"],
        queryFn: getComingSoon,
        staleTime: 1000 * 60 * 5, 
        refetchOnWindowFocus: false, 
    });

    return {
        comingSoon: data || [],
        loading: isLoading,
        error: isError ? error.message : null,
        refetch,
    };
}

export default useComingSoon;